import update from 'immutability-helper';
import { UPDATE_NAVIGATION_SECTIONS } from '../actions/navigation';

const initialState = {
    sections: null,
};

const navigation = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_NAVIGATION_SECTIONS: {
            return update(state, {
                sections: {
                    $set: action.sections,
                },
            });
        }
        default:
            return state;
    }
};

export default navigation;
